import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

['push', 'replace'].forEach(method => {
  const originalMethod = Router.prototype[method]
  Router.prototype[method] = function m (location) {
    return originalMethod
      .call(this, location)
      .catch(error => {
        if (error.name === 'NavigationDuplicated') return
        throw error
      })
  }
})

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      beforeEnter (to, from, next) {
        window.location.href = process.env.VUE_APP_PLATFORM_URL
      }
    },
    {
      path: '/cotacoes',
      name: 'quotations',
      component: () => import('@/views/Quotations'),
      meta: {
        slug: 'cotacoes',
        next: 'passengers'
      }
    },
    {
      path: '/passageiros',
      name: 'passengers',
      component: () => import('@/views/Passengers'),
      meta: {
        slug: 'passageiros',
        previous: 'quotations',
        next: 'additional'
      }
    },
    {
      path: '/obrigado',
      name: 'success',
      component: () => import('@/views/Success'),
      meta: {
        slug: 'obrigado'
      }
    },
    {
      path: '*',
      redirect: { name: 'home' }
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (to.name === 'home' && to.params.pathMatch === '/phones' && from.name === 'livelo') {
      const elm = document.querySelector('#phones').getBoundingClientRect()
      window.scrollTo(0, elm.top)
    }
  }
})

router.beforeEach(async (to, from, next) => {
  if (store.state.travelSetup.listDestinations.length === 0) await store.dispatch('travelSetup/getListDestinations')

  const {
    travelSetup,
    user,
    quotation,
    payment
  } = store.state

  const emptyPassengers = user.passengers.length === 0
  if (
    (/passengers|additional|success/.test(to.name) && !quotation.selectedQuote && emptyPassengers) ||
    (from.name === 'success' && payment.planUuid)
  ) {
    next({ path: '/' })
  }

  if (to.name === 'quotations' && (to.query.hasOwnProperty('countries') || to.query.hasOwnProperty('cod_destination'))) {
    await store.dispatch('travelSetup/init')
    store.dispatch('travelSetup/getUserData')
    store.commit('quotation/resetQuotation')

    /*
     * Código temporario até as cotações antigas finalizarem
     */

    const hasIdOld = to.query.countries && to.query.countries
      .split(',')
      .map(id => Number(id))
      .some(id => id < 237 && id !== 31)

    if (hasIdOld) store.commit('quotation/hasIdOld', hasIdOld)

    /* Fim */

    if (to.query.countries) {
      store.commit('quotation/hasNational', to.query.countries === '31')
      store.commit('quotation/setCountriesSelected', to.query.countries)
      store.commit('quotation/setIsNational', parseInt(to.query.countries) === store.getters['travelSetup/brasilTrip'].id)
    }
    if (to.query.cod_destination) store.commit('quotation/setDestination', to.query.cod_destination)
    if (to.query.initial_date) store.commit('quotation/setInitialDate', to.query.initial_date)
    if (to.query.end_date) store.commit('quotation/setEndDate', to.query.end_date)
    if (to.query.fourty_years) store.commit('quotation/setNumberOfPassengersFourtyYears', to.query.fourty_years)
    if (to.query.sixty_four_years) store.commit('quotation/setNumberOfPassengersSixtyFourYears', to.query.sixty_four_years)
    if (to.query.seventy_five_years) store.commit('quotation/setNumberOfPassengersSeventyFiveYears', to.query.seventy_five_years)
    if (to.query.eighty_five_years) store.commit('quotation/setNumberOfPassengersEightyFiveYears', to.query.eighty_five_years)
    if (to.query.ninety_nine_years) {
      store.commit(
        'quotation/setNumberOfPassengersNinetyNineYears',
        to.query.ninety_nine_years
      )
    }
    if (!store.state.quotation.hasNational && to.query.planCovidSelected) store.commit('quotation/setPlanCovidSelected', to.query.planCovidSelected)
    if (to.query.leadUuid) store.commit('travelSetup/changeLeadUuid', to.query.leadUuid)
    if (!store.state.quotation.hasNational && (to.query.planCovidSelected === '0' || !to.query.planCovidSelected) && !to.query.cod_destination) store.commit('quotation/setPlanCovidSelected', 1)
    if (!router.app.$partnerBB && to.query.promo_code) store.commit('quotation/setPromoCode', to.query.promo_code)
    else if (router.app.$partnerBB) store.commit('quotation/setPromoCode', 'BBSEGUROS80')

    const appSettings = travelSetup.appSettings
    if (appSettings.campaign && appSettings.promoCode.autoApply && appSettings.promoCode.code) store.commit('quotation/setPromoCode', appSettings.promoCode.code)

    if (!hasIdOld) store.dispatch('quotation/create')
  }

  if ('meta' in from && 'level' in from.meta && 'meta' in to && 'level' in to.meta) {
    Vue.transition.changeAnimationName(((from.meta.level || 0) < to.meta.level) ? 'up' : 'down')
  }

  next()
})

router.afterEach((to) => {
  const step = router.currentRoute.meta.slug || null
  store.dispatch('travelSetup/patchLeadAction', step)

  window.setTimeout(window.scrollTo(0, 0), 100)
})

export default router
